import React, { useState, useEffect } from "react";
import api from '../../config/axiosConfig';
import "./NuevaVenta.css";
import { Search, User } from "lucide-react";
import ModalRepresentantes from "./ModalRepresentantes ";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import Preloader from "../../components/Preloader";
import LocationDropdowns from "../../components/LocationDropdowns";
import { DocumentServices } from "../../services/DocumentService";
import { CategoriaService } from "../../services/CategoriaService";
import { RequisitoService } from "../../services/RequisitoService";
import { ProductService } from "../../services/ProductService";
import { ClienteService } from "../../services/ClienteService";
import { SaleService } from "../../services/SaleService";
import UbicacionVenta from "./UbicacionVenta";
import { UsuarioService } from "../../services/UsuarioService";
import Searchable from "../../components/Searchable";
import { LeadService } from "../../services/LeadService";

const NuevaVenta = ({
  token,
  user,
  initialData = {},
  readOnly = false,
  onSave,
}) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [currentStep, setCurrentStep] = useState(1);
  const [form, setForm] = useState({
    // Paso 1: Información del Cliente
    codigoCliente: initialData.codigoCliente || "",
    tipoDocumento: initialData.tipoDocumento || "",
    numeroDocumento: initialData.numeroDocumento || "",
    nombres: initialData.nombres || "",
    apellidoPaterno: initialData.apellidoPaterno || "",
    apellidoMaterno: initialData.apellidoMaterno || "",
    telefonoContacto: initialData.telefonoContacto || "",
    telefonoContacto2: initialData.telefonoContacto2 || "",
    nombresCompletos: initialData.nombresCompletos || "",
    vendedor_id: initialData.vendedor_id || "",

    // Paso 2: Datos de ubicación
    departamento: initialData.departamento || "",
    provincia: initialData.provincia || "",
    distrito: initialData.distrito || "",
    zone: initialData.zone || "",
    direccion: initialData.direccion || "",
    direccionReferencia: initialData.direccionReferencia || "",
    correoElectronico: initialData.correoElectronico || "",
    latitud: initialData.latitud || null,
    longitud: initialData.longitud || null,

    // Paso 3: Información del producto
    categoriaProducto: initialData.categoriaProducto || "",
    producto: initialData.producto || "",
    precio: initialData.precio || "",
    telefonoMigrar: initialData.telefonoMigrar || "",
    fechaInstalacion: initialData.fechaInstalacion || "",
    amPm: initialData.amPm || "",

  });

  const [productos, setProductos] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [error, setError] = useState("");
  const [errors, setErrors] = useState({});
  const [idLead, setIdLead] = useState(0);
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);
  const [requisitos, setRequisitos] = useState([]);
  const [loadingProductos, setLoadingProductos] = useState(false);
  const [loadingCategorias, setLoadingCategorias] = useState(false);
  const [fechaFormateada, setFechaFormateada] = useState("");
  const [horaFormateada, setHoraFormateada] = useState("");
  const [tiposDocumentos, setTiposDocumentos] = useState([]);
  const [representantes, setRepresentantes] = useState([]);
  const [vendedores, setVendedores] = useState([]);
  const [loadingVendedores, setLoadingVendedores] = useState(false);
  const [mostrarModalRepresentantes, setMostrarModalRepresentantes] =
    useState(false);

  // Estado para las ubicaciones
  const [locationData, setLocationData] = useState({
    department: initialData.department_id || "",
    province: initialData.province_id || "",
    district: initialData.district_id || "",
    zone: initialData.zone_id || "",
  });

  const handleBackToList = () => {
    navigate("/admin/ventas"); // ajusta según tu ruta de listado
  };

  useEffect(() => {
    if (form.tipoDocumento !== '4') {
      const nombresCompletos = `${form.nombres} ${form.apellidoPaterno} ${form.apellidoMaterno}`.trim();
      setForm(prev => ({ ...prev, nombresCompletos }));
    }
  }, [form.nombres, form.apellidoPaterno, form.apellidoMaterno, form.tipoDocumento]);


  // Función para validar que solo se ingresen números
  const validateNumericInput = (value) => {
    return value.replace(/[^0-9]/g, "");
  };

  // Función para manejar cambios en campos numéricos
  const handleNumericChange = (e) => {
    const { name, value } = e.target;
    const numericValue = validateNumericInput(value);
    setForm((prev) => ({
      ...prev,
      [name]: numericValue,
    }));
  };

  const abrirModalRepresentantes = () => setMostrarModalRepresentantes(true);
  const cerrarModalRepresentantes = () => setMostrarModalRepresentantes(false);

  const actualizarRepresentantes = (nuevosRepresentantes) => {
    setRepresentantes(nuevosRepresentantes);
    cerrarModalRepresentantes();
  };

  useEffect(() => {
    fetchCategorias();
    fetchRequisitos();
    fetchVendedores();
    cargarTipoDocumentos();
    if (searchParams.has('id_lead')) {
      fetchLeadDataByUrl();
    }
  }, [user, searchParams]);

  useEffect(() => {
    if (productos.length > 0 && form.producto && !form.precio) {
      const seleccionado = productos.find(p => p.id == form.producto);
      if (seleccionado) {
        setForm(prev => ({ ...prev, precio: seleccionado.precio }));
      }
    }
  }, [productos, form.producto]);

  useEffect(() => {
    const actualizarFechaHora = () => {
      const fechaActual = new Date();
      const opcionesFecha = {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      };
      setFechaFormateada(
        fechaActual.toLocaleDateString("es-ES", opcionesFecha)
      );
      setHoraFormateada(
        fechaActual.toLocaleTimeString("es-ES", {
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: true,
        })
      );
    };

    actualizarFechaHora();

  }, []);

  useEffect(() => {
    if (requisitos.length > 0) {
      const camposDocumentos = requisitos.reduce((acc, req) => {
        const campo = req.nombre_campo;
        acc[campo] = null;
        acc[`${campo}Preview`] = null;
        return acc;
      }, {});

      setForm((prev) => ({
        ...prev,
        ...camposDocumentos,
      }));
    }
  }, [requisitos]);

  const fetchLeadDataByUrl = async () => {
    const idLead = searchParams.get('id_lead');

    if (!idLead) return;

    try {
      const responseLead = await LeadService.getById({
        token: token,
        vid: idLead
      });

      if (responseLead.lead && typeof responseLead.lead.id !== 'undefined') {
        const { lead } = responseLead;
        setIdLead(idLead);

        if (lead.categoria_id) {
          fetchProductos(lead.categoria_id);
        }

        const newData = {
          ...(lead.id_tipo_documentos && { tipoDocumento: lead.id_tipo_documentos }),
          ...(lead.numero_documento && { numeroDocumento: lead.numero_documento }),
          ...(lead.nombres && { nombres: lead.nombres }),
          ...(lead.ap_paterno && { apellidoPaterno: lead.ap_paterno }),
          ...(lead.ap_materno && { apellidoMaterno: lead.ap_materno }),
          ...(lead.telefono_1 && { telefonoContacto: lead.telefono_1 }),
          ...(lead.telefono_2 && { telefonoContacto2: lead.telefono_2 }),
          ...(lead.email && { correoElectronico: lead.email }),
          ...(lead.direccion && { direccion: lead.direccion }),
          ...(lead.direccion_referencia && { direccionReferencia: lead.direccion_referencia }),
          ...(lead.categoria_id && { categoriaProducto: lead.categoria_id }),
          ...(lead.id_producto_solicita && { producto: lead.id_producto_solicita }),
        };

        const nombresCompletos = `${lead.nombres || ''} ${lead.ap_paterno || ''} ${lead.ap_materno || ''}`.trim();

        setLocationData((prev) => ({
          ...prev,
          department: String(lead.department_id || '').padStart(2, '0'),
          province: String(lead.province_id || '').padStart(4, '0'),
          district: String(lead.district_id || '').padStart(6, '0'),
          zone: lead.id_region,
        }));

        setForm((prevForm) => ({ ...prevForm, ...newData, nombresCompletos }));
      }
    } catch (error) {
      console.error("Error cargando el lead:", error);
    }
  };

  const fetchCategorias = async () => {
    setLoadingCategorias(true);
    try {
      const data = await CategoriaService.getCategorias(token);
      setCategorias(data);
    } catch (err) {
      console.error("Error al cargar categorías:", err);
    } finally {
      setLoadingCategorias(false);
    }
  };

  const fetchVendedores = async () => {
    setLoadingVendedores(true);
    try {
      const data = await UsuarioService.fetchVendedores(token);
      setVendedores(data);
    } catch (err) {
      console.error("Error al cargar categorías:", err);
    } finally {
      setLoadingVendedores(false);
    }
  };

  const cargarTipoDocumentos = async () => {
    try {
      const tipos = await DocumentServices.getDocuments(token);
      setTiposDocumentos(tipos || []);
    } catch (error) {
      console.error("Error al cargar tipos de Documentos:", error);
    }
  };

  const fetchRequisitos = async () => {
    try {
      const data = await RequisitoService.fetchRequisitos(token);
      setRequisitos(data);
    } catch (err) {
      console.error("Error al cargar requisitos:", err);
    }
  };

  const fetchProductos = async (value) => { 
    if (!value) return [];
    setLoadingProductos(true);
    try {
      const response = await ProductService.fetchProductosPorCategoria(token, value);
      setProductos(response.data);
      return response.data;
    } catch (err) {
      console.error("Error al cargar productos:", err);
      setError("Error al cargar los productos.");
    } finally {
      setLoadingProductos(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
    if (name === "categoriaProducto") {
      fetchProductos(value);
      setForm((prev) => ({ ...prev, producto: "", precio: "" }));
    }

    if (name === 'tipoDocumento') {
      setRepresentantes([]);
      if (idLead === 0) {
        setForm(prev => ({
          ...prev,
          nombres: "",
          apellidoPaterno: "",
          apellidoMaterno: "",
          nombresCompletos: "",
        }));
      }
    }

    if (name === "producto") {
      const productoSeleccionado = productos.find(p => p.id == value);

      if (productoSeleccionado) {
        setForm((prev) => ({
          ...prev,
          precio: productoSeleccionado.precio,
        }));
      }
    }
  };

  const handleFileChange = (fieldName, file) => {
    const MAX_FILE_SIZE_MB = 2;
    const ALLOWED_TYPES = ["image/jpeg", "image/png", "image/jpg", "image/webp", "application/pdf"];

    if (file) {
      const fileSizeMB = file.size / (1024 * 1024);
      const fileType = file.type;

      if (!ALLOWED_TYPES.includes(fileType)) {
        setErrors((prev) => ({
          ...prev,
          [fieldName]: "Solo se permiten imágenes o archivos PDF",
        }));
        return;
      }

      if (fileSizeMB > MAX_FILE_SIZE_MB) {
        setErrors((prev) => ({
          ...prev,
          [fieldName]: "El archivo no debe superar los 2 MB",
        }));
        return;
      }

      setErrors((prev) => ({
        ...prev,
        [fieldName]: null,
      }));

      const reader = new FileReader();
      reader.onload = (e) => {
        setForm({
          ...form,
          [fieldName]: file,
          [`${fieldName}Preview`]: e.target.result,
        });
      };
      reader.readAsDataURL(file);
    } else {
      setForm({
        ...form,
        [fieldName]: null,
        [`${fieldName}Preview`]: null,
      });
      setErrors((prev) => ({
        ...prev,
        [fieldName]: null,
      }));
    }
  };

  const nextStep = () => {
    if (currentStep < 5) {
      setCurrentStep(currentStep + 1);
      setError("");
    }
  };

  const prevStep = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
      setError("");
    }
  };

  const buscarCliente = async () => {
    try {
      if (!form.numeroDocumento || form.numeroDocumento.trim() === "") {
        setErrors((prev) => ({
          ...prev,
          numeroDocumento: "Ingrese un número válido",
        }));
        return;
      }

      const cliente = await ClienteService.buscarPorDocumento({
        token,
        tipoDocumento: form.tipoDocumento,
        numeroDocumento: form.numeroDocumento,
      });

      if (form.tipoDocumento === "1" && cliente) {
        setForm((prev) => ({
          ...prev,
          nombres: cliente.nombres || "",
          apellidoMaterno: cliente.apellido_materno || "",
          apellidoPaterno: cliente.apellido_paterno || "",
          nombresCompletos: cliente.nombres + " " + cliente.apellido_paterno + " " + cliente.apellido_materno
        }));
      }

      if (form.tipoDocumento === "4" && cliente) {
        setForm((prev) => ({
          ...prev,
          nombresCompletos: cliente.nombre_o_razon_social || "",
          direccion: cliente.direccion || "",
          departamento: cliente.ubigeo?.[0] || "",
          provincia: cliente.ubigeo?.[1] || "",
          distrito: cliente.ubigeo?.[2] || "",
        }));

        setLocationData((prev) => ({
          ...prev,
          department: cliente.ubigeo?.[0] || "",
          province: cliente.ubigeo?.[1] || "",
          district: cliente.ubigeo?.[2] || "",
          zone: "",
        }));
      }

      setErrors((prev) => ({
        ...prev,
        numeroDocumento: null,
      }));
    } catch (err) {
      const mensaje = err.response?.data?.error || err.message || "Error al consultar el servicio";
      setErrors((prev) => ({
        ...prev,
        numeroDocumento: mensaje,
      }));
    }
  }

  const validarCodigoCliente = async (codigo) => {
    try {
      const existe = await SaleService.validarCodigo(token, codigo);

      setErrors((prev) => ({
        ...prev,
        codigoCliente: existe ? "Este código ya está registrado" : null,
      }));
    } catch (error) {
      console.error("Error al validar código:", error);
      setErrors((prev) => ({
        ...prev,
        codigoCliente: "Error al validar el código",
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSuccess("");
    if (readOnly) return;

    const newErrors = {};

    if (currentStep === 1) {
      if (!form.tipoDocumento) {
        newErrors.tipoDocumento = "Tipo de documento es obligatorio";
      }

      if (!form.numeroDocumento) {
        newErrors.numeroDocumento = "Número de documento es obligatorio";
      }

      if (form.codigoCliente?.trim()) {
        const resultado = await SaleService.validarCodigo(token, form.codigoCliente);
        if (resultado.existe) {
          newErrors.codigoCliente = 'El código ya existe';
        }
      }

      if (form.tipoDocumento !== '4') {
        if (!form.nombres) {
          newErrors.nombres = "Nombres son obligatorios";
        }
        if (!form.apellidoPaterno) {
          newErrors.apellidoPaterno = "Apellido paterno es obligatorio";
        }
      } else {
        if (!form.nombresCompletos) {
          newErrors.nombresCompletos = "Razón Social es obligatorios";
        }
      }

      if (user?.permisos?.includes("register_vendores_venta") && !form.vendedor_id) {
        newErrors.vendedor_id = "Debe seleccionar un vendedor";
      }

      if (!form.telefonoContacto)
        newErrors.telefonoContacto = "Teléfono de contacto es obligatorio";
    }

    if (currentStep === 2) {
      if (!locationData.department)
        newErrors.department = "Departamento es obligatorio";
      if (!locationData.province)
        newErrors.province = "Provincia es obligatoria";
      if (!locationData.district)
        newErrors.district = "Distrito es obligatorio";
      if (!form.direccion) newErrors.direccion = "Dirección es obligatoria";
    }

    if (currentStep === 3) {
      if (form.latitud === null || form.longitud === null) {
        newErrors.ubicacion = 'Debe seleccionar una ubicación en el mapa';
      }
    }

    if (currentStep === 4) {
      if (!form.categoriaProducto)
        newErrors.categoriaProducto = "Categoría es obligatoria";
      if (!form.producto) newErrors.producto = "Producto es obligatorio";
      if (!form.precio) newErrors.precio = "Precio es obligatorio";
    }

    if (currentStep === 5) {
      requisitos.forEach((req) => {
        const fieldName = req.nombre_campo;
        const isRequired = req.obligatorio === "1";

        if (
          isRequired &&
          fieldName &&
          !form[fieldName] && 
          !form[`${fieldName}Preview`] 
        ) {
          newErrors[fieldName] = `${req.descripcion} es obligatorio.`;
        }
      });
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors); 
      return;
    }

    if (currentStep < 5) {
      nextStep();
      return;
    }

    setLoading(true);
    try {
      const getLocation = () =>
        new Promise((resolve, reject) => {
          if (!navigator.geolocation) return reject(new Error("Geolocalización no soportada"));
          navigator.geolocation.getCurrentPosition(
            (position) => resolve(position.coords),
            (error) => reject(error),
            { enableHighAccuracy: true, timeout: 10000 }
          );
        });

      let coords = {};
      try {
        coords = await getLocation(); 
      } catch (geoError) {
        console.warn("No se pudo obtener ubicación:", geoError.message);
      }

      const formData = new FormData();

      formData.append("producto", form.producto);
      formData.append("monto", parseFloat(form.precio) || 0.0);
      formData.append("codigoCliente", form.codigoCliente);
      formData.append("tipoDocumento", form.tipoDocumento);
      formData.append("numeroDocumento", form.numeroDocumento);
      formData.append("nombres", form.nombres);
      formData.append("idLead", idLead);
      formData.append("apellidoPaterno", form.apellidoPaterno);
      formData.append("apellidoMaterno", form.apellidoMaterno);
      formData.append("telefonoContacto", form.telefonoContacto);
      formData.append("telefonoContacto2", form.telefonoContacto2);
      formData.append("nombresCompletos", form.nombresCompletos);
      formData.append("representantes", JSON.stringify(representantes));
      formData.append("vendedor_id", form.vendedor_id);

      formData.append(
        "departamento",
        locationData.department || form.departamento
      );
      formData.append("provincia", locationData.province || form.provincia);
      formData.append("distrito", locationData.district || form.distrito);
      formData.append("zone", locationData.zone || form.zone);
      formData.append("direccion", form.direccion);
      formData.append("direccionReferencia", form.direccionReferencia);
      formData.append("correoElectronico", form.correoElectronico);
      formData.append("latitud_cliente", String(form.latitud));
      formData.append("longitud_cliente", String(form.longitud));

      if (coords.latitude && coords.longitude) {
        formData.append("latitud", coords.latitude.toString());
        formData.append("longitud", coords.longitude.toString());
      }

      formData.append("ventaDetalleId", form.ventaDetalleId);
      formData.append("categoriaProducto", form.categoriaProducto);
      formData.append("precio", form.precio);
      formData.append("telefonoMigrar", form.telefonoMigrar);
      formData.append("fechaInstalacion", form.fechaInstalacion);
      formData.append("amPm", form.amPm);
      formData.append("origen", 'web');

      requisitos.forEach((req) => {
        const fieldName = req.nombre_campo;
        const file = form[fieldName];

        if (file instanceof File) {
          formData.append(fieldName, file);
        }
      });

      const response = await api.post("/ventas", formData, {
        headers: { Authorization: `Bearer ${token}` },
        "Content-Type": "multipart/form-data",
      });

      if (response.data.success) {

        toast.success(response.data.message || "Venta registrada correctamente");

        navigate("/admin/ventas");
      } else {
        toast.error(response.data.message || "Error al registrar la venta");
      }
    } catch (err) {
      toast.error("Error al registrar la venta: " + error.message, {
        position: "top-center",
        autoClose: 3000,
        theme: "colored",
      });
    } finally {
      setLoading(false);
    }
  };

  const renderStep1 = () => (
    <div className="form-section">
      <h3 className="section-title">Datos del Cliente</h3>

      <div className="form-grid">
        <div className="">
          <label htmlFor="codigoCliente">Código de Cliente</label>
          <input
            type="text"
            name="codigoCliente"
            value={form.codigoCliente}
            onChange={(e) => {
              handleChange(e);
              validarCodigoCliente(e.target.value); // o usar onBlur si prefieres
            }}
            disabled={readOnly}
            placeholder="Código del cliente"
          />
          {errors.codigoCliente && (
            <span className="error">{errors.codigoCliente}</span>
          )}
        </div>
        <div className="">
          <label htmlFor="tipoDocumento">Tipo de Documento *</label>
          <select
            name="tipoDocumento"
            value={form.tipoDocumento}
            onChange={handleChange}
            disabled={readOnly}
          >
            <option value="">Selecciona tipo de documento</option>
            {tiposDocumentos.map((tipo) => (
              <option key={tipo.id} value={tipo.id}>
                {tipo.description}
              </option>
            ))}
          </select>
          {errors.tipoDocumento && (
            <span className="error">{errors.tipoDocumento}</span>
          )}
        </div>
      </div>

      <div className="form-grid">
        <div className="">
          <label htmlFor="numeroDocumento">Número de Documento *</label>
          <div className="input-with-button">
            <input
              type="text"
              name="numeroDocumento"
              value={form.numeroDocumento}
              onChange={handleNumericChange}
              disabled={readOnly}
              placeholder="Solo números"
            />
            {(form.tipoDocumento === "1" || form.tipoDocumento === "4") && (
              <button
                type="button"
                className="search-btn"
                title="Buscar cliente"
                onClick={buscarCliente}
              >
                <Search size={20} color="#ffffff" />
              </button>
            )}
          </div>
          {errors.numeroDocumento && (
            <span className="error">{errors.numeroDocumento}</span>
          )}
        </div>
        <div className="">
          <label htmlFor="nombres">Nombres</label>
          <input
            type="text"
            name="nombres"
            value={form.nombres}
            onChange={handleChange}
            disabled={readOnly}
            readOnly={form.tipoDocumento === '4'}
            placeholder="Nombres del cliente"
          />
          {errors.nombres && <span className="error">{errors.nombres}</span>}
        </div>
      </div>

      <div className="form-grid">
        <div className="">
          <label htmlFor="apellidoPaterno">Apellido Paterno </label>
          <input
            type="text"
            name="apellidoPaterno"
            value={form.apellidoPaterno}
            onChange={handleChange}
            disabled={readOnly}
            readOnly={form.tipoDocumento === '4'}
            placeholder="Apellido paterno"
          />
          {errors.apellidoPaterno && (
            <span className="error">{errors.apellidoPaterno}</span>
          )}
        </div>
        <div className="">
          <label htmlFor="apellidoMaterno">Apellido Materno</label>
          <input
            type="text"
            name="apellidoMaterno"
            value={form.apellidoMaterno}
            onChange={handleChange}
            disabled={readOnly}
            readOnly={form.tipoDocumento === '4'}
            placeholder="Apellido materno"
          />
          {errors.apellidoMaterno && (
            <span className="error">{errors.apellidoMaterno}</span>
          )}
        </div>
      </div>

      <div className="form-grid">
        <div className="">
          <label htmlFor="telefonoContacto">Teléfono de Contacto *</label>
          <input
            type="tel"
            name="telefonoContacto"
            value={form.telefonoContacto}
            onChange={handleNumericChange}
            disabled={readOnly}
            placeholder="Solo números"
          />
          {errors.telefonoContacto && (
            <span className="error">{errors.telefonoContacto}</span>
          )}
        </div>
        <div className="">
          <label htmlFor="nombresCompletos">Nombres Completos / Razón Social</label>
          <div className="input-with-button">
            <input
              type="text"
              name="nombresCompletos"
              value={form.nombresCompletos}
              onChange={handleChange}
              disabled={readOnly}
              readOnly={form.tipoDocumento !== '4'}
              placeholder="Nombres completos - Razón social..."
            />
            {form.tipoDocumento === "4" && (
              <button
                type="button"
                className="contact-btn"
                title="Seleccionar contacto"
                onClick={abrirModalRepresentantes}
              >
                <User size={24} color="white" />
              </button>
            )}
          </div>
          {mostrarModalRepresentantes && (
            <ModalRepresentantes
              clientesSeleccionados={representantes}
              onGuardar={actualizarRepresentantes}
              onCerrar={cerrarModalRepresentantes}
              numero={form.numeroDocumento}
              tipoDocumento={form.tipoDocumento}
              token={token}
            />
          )}
          {errors.nombresCompletos && (
            <span className="error">{errors.nombresCompletos}</span>
          )}
        </div>
      </div>
    </div>
  );

  const renderStep2 = () => {
    return (
      <div className="form-section">
        <h3 className="section-title"> Dirección del cliente</h3>

        <LocationDropdowns
          selectedDepartment={locationData.department}
          selectedProvince={locationData.province}
          selectedDistrict={locationData.district}
          selectedZone={locationData.zone}
          errors={errors}
          onDepartmentChange={(value) => {
            setLocationData((prev) => ({
              ...prev,
              department: value,
              province: "",
              district: "",
              zone: "",
            }));
            // Sincronizar con form
            setForm((prev) => ({
              ...prev,
              departamento: value,
              provincia: "",
              distrito: "",
              zone: "",
            }));
          }}
          onProvinceChange={(value) => {
            setLocationData((prev) => ({
              ...prev,
              province: value,
              district: "",
              zone: "",
            }));
            // Sincronizar con form
            setForm((prev) => ({
              ...prev,
              provincia: value,
              distrito: "",
              zone: "",
            }));
          }}
          onDistrictChange={(value) => {
            setLocationData((prev) => ({
              ...prev,
              district: value,
              zone: "",
            }));
            // Sincronizar con form
            setForm((prev) => ({
              ...prev,
              distrito: value,
              zone: "",
            }));
          }}
          onZoneChange={(value) => {
            setLocationData((prev) => ({
              ...prev,
              zone: value,
            }));
            // Sincronizar con form
            setForm((prev) => ({
              ...prev,
              zone: value,
            }));
          }}
          showZones={true}
          className="location-dropdowns"
          token={token}
        />

        <div className="form-grid">
          <div className="form-group">
            <label htmlFor="correoElectronico">Correo Electrónico</label>
            <input
              type="email"
              name="correoElectronico"
              value={form.correoElectronico}
              onChange={handleChange}
              disabled={readOnly}
              placeholder="Correo electrónico"
            />
            {errors.correoElectronico && (
              <span className="error">{errors.correoElectronico}</span>
            )}
          </div>
          <div className="form-group">
            <label htmlFor="telefonoContacto2">Teléfono de Contacto (Opcional)</label>
            <input
              type="tel"
              name="telefonoContacto2"
              value={form.telefonoContacto2}
              onChange={handleNumericChange}
              disabled={readOnly}
              placeholder="Solo números (opcional)"
            />
            {errors.telefonoContacto2 && (
              <span className="error">{errors.telefonoContacto2}</span>
            )}
          </div>
        </div>

        <div className="form-grid">
          <div className="form-group">
            <label htmlFor="direccion">Dirección *</label>
            <textarea
              name="direccion"
              value={form.direccion}
              onChange={handleChange}
              disabled={readOnly}
              placeholder="Dirección"
              rows={3} 
              style={{ resize: "vertical" }} 
            />
            {errors.direccion && (
              <span className="error">{errors.direccion}</span>
            )}
          </div>
          <div className="form-group">
            <label htmlFor="direccionReferencia">Dirección de Referencia</label>
            <textarea
              name="direccionReferencia"
              value={form.direccionReferencia}
              onChange={handleChange}
              disabled={readOnly}
              placeholder="Dirección de referencia"
              rows={3}
              style={{ resize: "vertical" }}
            />
            {errors.direccionReferencia && (
              <span className="error">{errors.direccionReferencia}</span>
            )}
          </div>
        </div>
      </div>
    );
  };

  const renderStep3 = () => {
    return (
      <div className="form-section">
        <h3 className="section-title">Ubicación en el mapa</h3>
        <p>Verifica la ubicación aproximada del cliente en el mapa:</p>
        <UbicacionVenta form={form} setForm={setForm} />
      </div>
    );
  };

  const renderStep4 = () => (
    <div className="form-section">
      <h3 className="section-title">Datos del Producto</h3>

      <div className="form-grid">
        <div className="form-group">
          <label htmlFor="categoriaProducto">Categoría Producto *</label>
          <select
            name="categoriaProducto"
            value={form.categoriaProducto}
            onChange={handleChange}
            disabled={readOnly || loadingCategorias}
            className="form-select"
          >
            <option value="">Seleccionar categoría</option>
            {categorias.map((categoria) => (
              <option key={categoria.id} value={categoria.id}>
                {categoria.nombre}
              </option>
            ))}
          </select>
          {errors.categoriaProducto && (
            <span className="error">{errors.categoriaProducto}</span>
          )}
        </div>
        <div className="form-group">
          <label htmlFor="producto">Producto *</label>
          <select
            name="producto"
            value={form.producto}
            onChange={handleChange}
            disabled={readOnly || !form.categoriaProducto}
            className="form-select"
          >
            <option value="">Seleccionar producto</option>
            {productos.map((producto) => (
              <option key={producto.id} value={producto.id}>
                {producto.nombre} - S/ {producto.precio}
              </option>
            ))}
          </select>
          {errors.producto && <span className="error">{errors.producto}</span>}
        </div>
      </div>

      <div className="form-grid">
        <div className="form-group">
          <label htmlFor="precio">Precio *</label>
          <input
            type="number"
            name="precio"
            value={form.precio}
            onChange={handleChange}
            disabled={readOnly}
            readOnly={true}
            step="0.01"
            placeholder="Precio"
          />
          {errors.precio && <span className="error">{errors.precio}</span>}
        </div>
        <div className="form-group">
          <label htmlFor="telefonoMigrar">Teléfono a Migrar</label>
          <input
            type="tel"
            name="telefonoMigrar"
            value={form.telefonoMigrar}
            onChange={handleNumericChange}
            disabled={readOnly}
            placeholder="Solo números"
          />
          {errors.telefonoMigrar && (
            <span className="error">{errors.telefonoMigrar}</span>
          )}
        </div>
      </div>

      <div className="form-grid">
        <div className="form-group">
          <label htmlFor="fechaInstalacion">Fecha de Instalación</label>
          <input
            type="datetime-local"
            name="fechaInstalacion"
            value={form.fechaInstalacion}
            onChange={handleChange}
          />
          {errors.fechaInstalacion && (
            <span className="error">{errors.fechaInstalacion}</span>
          )}
        </div>
        {/* <div className="form-group">
          <label>AM/PM</label>
          <select
            name="amPm"
            value={form.amPm}
            onChange={handleChange}
            disabled={readOnly}
          >
            <option value="">Seleccionar</option>
            {opcionesAmPm.map((opcion) => (
              <option key={opcion.value} value={opcion.value}>
                {opcion.label}
              </option>
            ))}
          </select>
          {errors.amPm && <span className="error">{errors.amPm}</span>}
        </div> */}
      </div>
    </div>
  );

  const renderStep5 = () => (
    <div className="form-section">
      <h3 className="section-title">📷 Documentos Requeridos</h3>

      <div className="document-grid">
        {requisitos.map((req) => {
          const fieldName = req.nombre_campo;
          const previewField = `${fieldName}Preview`;
          const isRequired = req.obligatorio === "1";
          const preview = form?.[previewField];

          return (
            <div className="document-card" key={req.id}>
              {preview ? (
                <div className="image-preview">
                  <img src={preview} alt={req.descripcion} />
                  <button
                    type="button"
                    className="remove-image"
                    onClick={() => handleFileChange(fieldName, null)}
                  >
                    ✕
                  </button>
                </div>
              ) : (
                <div className="document-icon">📷</div>
              )}

              <label>
                {req.descripcion} {isRequired && "*"}
              </label>

              <input
                type="file"
                accept="image/*,.pdf"
                onChange={(e) =>
                  handleFileChange(fieldName, e.target.files[0])
                }
                disabled={readOnly}
              />

              {errors?.[fieldName] && (
                <span className="error">{errors[fieldName]}</span>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );

  const renderCurrentStep = () => {
    switch (currentStep) {
      case 1:
        return renderStep1();
      case 2:
        return renderStep2();
      case 3:
        return renderStep3();
      case 4:
        return renderStep4();
      case 5:
        return renderStep5();
      default:
        return renderStep1();
    }
  };

  return (
    <div className="ventas-admin-content">
      {loading && <Preloader />}
      <div className="breadcrumb-container">
        <span className="breadcrumb-link" onClick={handleBackToList}>
          ← Listado de Ventas
        </span>
        <span className="breadcrumb-current"> / Registrar Venta</span>
      </div>
      <div className="dashboard-card nueva-venta-responsive">
        <span className="nueva-venta-title"> Nueva Venta</span>
        {user?.permisos?.includes("register_vendores_venta") ? (
          <span className="nueva-venta-subtitle">
            <div className="selector-vendedor">
              <label htmlFor="vendedor">Seleccionar vendedor:</label>

              <Searchable
                options={vendedores} // [{id, nombre, apellidoPaterno}]
                value={form.vendedor_id}
                onChange={(id) => setForm({ ...form, vendedor_id: id })}
                placeholder="Seleccione vendedor..."
                getOptionLabel={(v) => `${v.nombre} ${v.apellidoPaterno}`}
                getOptionValue={(v) => v.id}
              />
              {errors.vendedor_id && (
                <span className="error">{errors.vendedor_id}</span>
              )}
            </div>
          </span>
        ) : (
          <span className="nueva-venta-subtitle">
            {user.perfil_nombre} - {user.nombre + " " + user.apellidoPaterno}
          </span>
        )}
        <span className="nueva-venta-subtitle">
          {fechaFormateada}
        </span>

        <form
          className="nueva-venta-form"
          onSubmit={handleSubmit}
          autoComplete="off"
        >
          {renderCurrentStep()}

          {error && <div className="error-message">{error}</div>}
          {success && <div className="success-message">{success}</div>}

          {!readOnly && (
            <div className="form-actions">
              {currentStep > 1 && (
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={prevStep}
                  disabled={loading}
                >
                  Anterior
                </button>
              )}

              <button
                className="btn btn-primary"
                type="submit"
                disabled={loading}
              >
                {loading
                  ? "Procesando..."
                  : currentStep === 5
                    ? "Registrar Venta"
                    : "Siguiente"}
              </button>
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

export default NuevaVenta;
